export enum AsymmetrySeverityEnum {
  SOUND = 'sound',
  VERU_MILD = 'veryMild',
  MILD = 'mild',
  MODERATE = 'moderate',
  SEVERE = 'severe',
}

export enum AsymmetrySeverityVariableThresholdEnum {
  sound = 'sound',
  veryMild = 'very mild',
  mild = 'mild',
  moderate = 'moderate',
  severe = 'severe',
}

export enum AsymmetrySeverityWeightsEnum {
  sound = 0,
  veryMild = 10,
  mild = 20,
  moderate = 30,
  severe = 50,
}
